//Third party libraries
import { useSelector } from 'react-redux';

//Custom components
import DashboardWidget from '@/components/DashboardWidget';
import ConstructionTypeWidget from '@/components/Widgets/ConstructionTypeWidget';
import { DashboardName, Widget } from '@/components/Widgets/constants';
import DeliverableWidget from '@/components/Widgets/DeliverableWidget';
import MilestoneWidget from '@/components/Widgets/MilestoneWidget';
import ProjectBudgetSummaryWidget from '@/components/Widgets/ProjectBudgetSummaryWidget';
import ProjectLocationWidget from '@/components/Widgets/ProjectLocationWidget';
import ProjectTypeWidget from '@/components/Widgets/ProjectTypeWidget';
import TaskWidget from '@/components/Widgets/TaskWidget';

//Services
import { useDashboardWidgetsList } from '../../hooks/ReactQueryHooks/useDashboardQuery';
import { authSelector } from '../../store';

export default function MyDashboard() {
  const { data: currentUserData } = useSelector(authSelector);
  const { isWidgetUsed } = useDashboardWidgetsList({
    dashboard: DashboardName.USER_DASHBOARD,
  });

  return (
    <div className='max-w-screen-3xl mx-auto'>
      <h2 className='mb-0'>Welcome Back {currentUserData.name.split(' ')[0]},</h2>
      <div className='mb-4 -mt-6'>
        <DashboardWidget dashboard={DashboardName.USER_DASHBOARD} />
      </div>
      <div className='grid grid-cols-3 gap-8 items-start'>
        {isWidgetUsed?.[Widget.TASKS_COUNT] && <TaskWidget dashboard={DashboardName.USER_DASHBOARD} />}
        {isWidgetUsed?.[Widget.DELIVERABLES_COUNT] && <DeliverableWidget dashboard={DashboardName.USER_DASHBOARD} />}
        {isWidgetUsed?.[Widget.MILESTONES_COUNT] && <MilestoneWidget dashboard={DashboardName.USER_DASHBOARD} />}
      </div>
      {isWidgetUsed?.[Widget.PROJECT_LOCATION] && (
        <div className='mt-5'>
          <ProjectLocationWidget dashboard={DashboardName.USER_DASHBOARD} />
        </div>
      )}
      <section className='grid xl:grid-cols-2 gap-8 mt-8'>
        {isWidgetUsed?.[Widget.PROJECTS_BY_CONSTRUCTION_TYPE] && <ConstructionTypeWidget dashboard={DashboardName.USER_DASHBOARD} />}
        {isWidgetUsed?.[Widget.PROJECTS_BY_PROJECT_TYPE] && <ProjectTypeWidget dashboard={DashboardName.USER_DASHBOARD} />}
      </section>
      <div className='grid xl:grid-cols-2 gap-10 mt-8'>
        <section className='xl:col-span-1'>
          {isWidgetUsed?.[Widget.PROJECT_BUDGET_SUMMARY] && <ProjectBudgetSummaryWidget dashboard={DashboardName.USER_DASHBOARD} />}
        </section>
      </div>
    </div>
  );
}
